  <template>
  <div>
  <b-modal style="padding:15px" size="lg" id="AddUnitRateModal" ref="modal" title="Add Unit Rate" ok-title="Submit" cancel-title="Close" 
      @show= "resetModal()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddUnitRateForm != undefined ? !this.$refs.AddUnitRateForm.checkValidity() : true">
        <form ref="AddUnitRateForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <!--NAME INPUT-->
              <b-form-group  label="Effective From" label-for="datepicker-1" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "EffectiveDate" placeholder="Choose a date" local="en" required></b-form-datepicker>
               </b-form-group>
            </div>
            <div class="col-md-6">
               <b-form-group  label="Unit Rate" label-for="Unit Rate" autocomplete="off">
                <b-form-input id="unitrate" v-model= "Rate" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
            
          </div>
                  
        </form>
      </b-modal>
      <Toaster ref="toaster" />
      </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster';
export default {
    name: 'AddUnitRate',
    data(){
        return{
          moduleName:'Add Unit Rate',
          Rate:null,
          EffectiveDate:null,
		}
  },
  components:
  {
      Toaster
  },


methods:{

    addWheatIssue(){ 
     axios.post('/unitrate/Add', 
      {
          "Rate":this.Rate,"EffectiveDate":this.EffectiveDate,
        "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id
      
      })
      .then(res=>{
        // console.log(res)
            if(res.data.status == 1)
            {
                
                this.$refs.toaster.showToast('Success','success','Rate has been added successfully')
                 this.$bvModal.hide('AddUnitRateModal');
                 this.$parent.getPage(1);       
            }
             else if(res.data.status == -1)
            {
                 this.$refs.toaster.showToast('Error','danger',res.data.msg)
                
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddUnitRateForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.EffectiveDate = null;
        this.Rate = null;
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addWheatIssue()
        
       
      },
 
  
  },
	

}
</script>
